import { api } from "./apiService"

// AFTER
export const AddLeaveAdjustments = async (
  empServiceNo,
  leaveType,
  adjustmentDate,
  days,
  adjustmentType,
  reason,
  createdBy
) => {
  console.log("[LEAVE ADJUSTMENTS] Adding leave adjustments.....")

  try {
    const url = `/LeaveAdj/SetLeaveAdj?p_empServiceNo=${encodeURIComponent(empServiceNo)}&p_leaveType=${encodeURIComponent(leaveType)}&p_adjustmentDate=${encodeURIComponent(adjustmentDate)}&p_days=${encodeURIComponent(days)}&p_adjustmentType=${encodeURIComponent(adjustmentType)}&p_reason=${encodeURIComponent(reason)}&p_createdBy=${encodeURIComponent(createdBy)}`

    const response = await api.post(url)
    console.log("[LEAVE ADJUSTMENTS] Add leave adjustments -> ", response)

    const body = response?.data ?? response
    const statusCode = body?.StatusCode

    if (statusCode !== undefined && statusCode !== 200) {
      throw new Error(body?.Result || body?.Message || `Server error (status ${statusCode})`)
    }

    return response
  } catch (error) {
    console.log("[LEAVE ADJUSTMENTS] Add Leave adjustments error -> ", error)
    throw error
  }
}

export const FetchLeaveAdjestment = async (empServiceNo) => {
  if (!empServiceNo) {
    throw new Error("empServiceNo is required")
  }

  const url = `/LeaveAdj/GetLeaveAdj?p_empServiceNo=${encodeURIComponent(empServiceNo)}`

  try {
    const response = await api.get(url)
    console.log("[Leave Adjustment] Fetching leave adjustments -> ", response)
    return response
  } catch (error) {
    console.log("[Leave Adjustment] Fetch leave adjustments error -> ", error)
    throw error
  }
}